import React from 'react';

import useToggleController from "../../../../hooks/controller/useToggleController";
import SceneController from "../molecules/SceneController";
import BackgroundController from "../molecules/BackgroundController";
import ExtOnlyControllers from "../atoms/ExtOnlyControllers";
import IntOnlyControllers from "../atoms/IntOnlyControllers";
import MovingParts from "../../../independent/MovingParts";
import {shallowEqual, useSelector} from "react-redux";
import CaptureButton from "../atoms/CaptureButton";

const EnvControllers = () => {


  const {backgroundView, connectMode} = useSelector(state => ({
    backgroundView: state.toggle.backgroundView,
    connectMode: state.theme.connectMode
  }),shallowEqual);

  const {
    lightEvent,
    extLight,
    intLight,
    hotspotEvent,
    camera,
    attract,
    attractView
  } = useToggleController();



  return (
    <div className="view-control-wrap" data-camera-open={attract} data-background-open={backgroundView}>
      {connectMode === "remote" && <MovingParts/> }
      <SceneController setAttract={attractView} />
      <div className="controls">
        <BackgroundController/>
        {camera.currentCameraType === "EXT"
          ? <ExtOnlyControllers light={extLight} lightEvent={lightEvent} hotspotEvent={hotspotEvent}/>
          : <IntOnlyControllers light={intLight} lightEvent={lightEvent}/>
        }
        {
          connectMode === "web" ? <CaptureButton/> : null
        }

      </div>
    </div>
  )
}

export default EnvControllers;
